import { DetailsType } from './types'

export const details: DetailsType = {
  // stage1
  1: [
    [
      {
        type: 'text',
        content: `在巡弋飛椅的椅子上，可以看到不同顏色的椅子各有數字1~7不同的編號，例如：藍色巡弋飛椅的編號為5，代表藍色箭頭要順時針轉五格，會轉到E的位置。`,
      },
    ],
    [
      {
        type: 'text',
        content: `黃色箭頭旋鈕會轉4格至M的位置；
紫色箭頭旋鈕會轉7格至I的位置；
橘色箭頭旋鈕會轉6格至R的位置；
依此規則將綠色、粉色、棕色、藍色箭頭都旋轉至指定位置，
可以組成英文MIR _ _ _ _，
將MIR _ _ _ _輸入為答案，即可破解此關。`,
      },
    ],
  ],
  // stage2
  2: [
    [
      {
        type: 'text',
        content: `結界裡有九個圖案，每個太空人都可以配對到其中一個圖案，從左到右分別為「薩克斯風->整顆月亮->彎月->地球->五角星星」，在網頁中的結界將這五個圖案連線，即可得到線索「吉他到雲朵間」。`,
      },
    ],
    [
      {
        type: 'text',
        content: `在網頁中的結界將這五個圖案連線，即可得到線索「吉他到雲朵間」，找到吉他到雲朵間的兩個字，將該二字輸入為答案，即可破解此關。`,
      },
    ],
  ],
  // stage3
  3: [
    [
      {
        type: 'text',
        content: `抬頭往上看去，美食街上方有一系列的幾何圖形，找找每個圖形各有幾個即可知道這些幾何圖形分別代表數字1~6的哪一個數字。`,
      },
    ],
    [
      {
        type: 'text',
        content: `第二行算式可轉換成3+2=E，
5=E，E為英文字母中順序5的字母。
第五行算式可轉換成5X4-2=R，
18=R，R為英文字母中順序18的字母。
故可以知道每一個算式的答案，依照英文字母順序，即可獲得最後的英文解答，從上而下分別為ME _ _ R _，將ME _ _ R _輸入答案，即可破解此關。`,
      },
    ],
  ],
  // stage4
  4: [
    [
      {
        type: 'text',
        content: `在海盜船右側的三棵仙人掌即是正確的三棵仙人掌，分別為黃色、綠色及粉紅色。`,
      },
    ],
    [
      {
        type: 'text',
        content: `將黃色、綠色及粉紅色仙人掌上的注音，依序刪去「ㄌㄥˇㄇㄛˋ」，最後留下來的注音可以得到兩個國字，將該二字輸入在答案區，即可破解此關。`,
      },
    ],
  ],
  // stage5
  5: [
    [
      {
        type: 'text',
        content: `在海底總動員的上方可以看到依序排列的海洋生物，即可找到小丑魚後方的生物為黑白條紋相間的魚，海星前方則是魟魚。`,
      },
    ],
    [
      {
        type: 'text',
        content: `在網頁上找到兩種生物，他們四周的符號各可以組成一個字，輸入該二字，即可破解此關。`,
      },
    ],
  ],
  6: [
    [
      {
        type: 'text',
        content: `他們的紀念日與我們同天，今年為「6」週年，紀念日為「12」月「12」號，重要數字分別為6跟12。`,
      },
    ],
    [
      {
        type: 'text',
        content: `找到6號摩天輪及12號摩天輪的顏色，在網頁上找到該兩種顏色的氣球，分別可以組成二字，輸入該二字，即可破解此關。`,
      },
    ],
  ],
}
